import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";
import React from 'react';

import clsx from 'clsx';
const useStyle = makeStyles({
    root: {
        cursor: 'pointer',
        textAlign: 'center',
        display: 'flex',
        '&:hover p,&:hover svg,& img': {
            opacity: 1,
        },
        '& p, svg': {
            opacity: 0.4,
        },
        '&:hover img': {
            opacity: 0.3,
        },
    },
    noMouseEvent: {
        pointerEvents: 'none',
    },
    iconText: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'absolute',
    },
    hidden: {
        display: 'none',
    },
    onDragOver: {
        '& img': {
            opacity: 0.3,
        },
        '& p, svg': {
            opacity: 1,
        },
    },
});
export default function MultiFileUpload({ accept, imageButton = false,
    hoverLabel = 'Click or drag to upload file',
    dropLabel = 'Drop file here', width = '600px', height = '100px',
    backgroundColor = '#fff', image: { url = null, imageStyle = {
        height: 'inherit',
    } } = {}, onChange, onDrop, id }) {
    const classes = useStyle();
    const [imageUrls, setImageUrls] = React.useState(imageButton && url ? [url] : []);
    const [labelText, setLabelText] = React.useState(hoverLabel);
    const [isDragOver, setIsDragOver] = React.useState(false);
    const [isMouseOver, setIsMouseOver] = React.useState(false);
    const stopDefaults = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };
    const dragEvents = {
        onMouseEnter: () => {
            setIsMouseOver(true);
        },
        onMouseLeave: () => {
            setIsMouseOver(false);
        },
        onDragEnter: (e) => {
            stopDefaults(e);
            setIsDragOver(true);
            setLabelText(dropLabel);
        },
        onDragLeave: (e) => {
            stopDefaults(e);
            setIsDragOver(false);
            setLabelText(hoverLabel);
        },
        onDragOver: stopDefaults,
        onDrop: (e) => {
            stopDefaults(e);
            setLabelText(hoverLabel);
            setIsDragOver(false);
            const files = Array.from(e.dataTransfer.files);
            if (imageButton) {
                const urls = files.map(file => URL.createObjectURL(file));
                setImageUrls(urls);
            }
            onDrop(e, files);
        },
    };
    const handleChange = (event) => {
        const files = Array.from(event.target.files);
        if (imageButton) {
            const urls = files.map(file => URL.createObjectURL(file));
            setImageUrls(urls);
        }
        onChange(event, files);
    };
    return (
        <>
            <input
                onChange={handleChange}
                accept={accept}
                className={classes.hidden}
                id={'file-upload-' + id}
                type="file"
                multiple  // Enable multiple file selection
            />

            <label
                htmlFor={'file-upload-' + id}
                {...dragEvents}
                className={clsx(classes.root, isDragOver && classes.onDragOver)}
            >
                <Box
                    width={width}
                    height={height}
                    bgcolor={backgroundColor}
                    className={classes.noMouseEvent}
                >
                    {imageButton && (
                        <Box position="absolute" height={height} width={width}>
                            {imageUrls.map((imageUrl, index) => (
                                <img
                                    key={index}
                                    alt={`file-${index}`}
                                    src={imageUrl}
                                    style={imageStyle}
                                />
                            ))}
                        </Box>
                    )}

                    {(!imageButton || isDragOver || isMouseOver) && (
                        <>
                            <Box
                                height={height}
                                width={width}
                                className={classes.iconText}
                            >
                                <CloudUploadIcon fontSize="large" />
                                <Typography>{labelText}</Typography>
                            </Box>
                        </>
                    )}
                </Box>
            </label>
        </>
    );
};
